import { defineFcm } from '../shared/factory';

export const FCM_DM_ABOUT_PAGE = defineFcm('dm_about_page').asBoolean().withDefault(false).toConfig({
	owner: 'squad-capybara',
	scope: 'TBD',
	context: 'General DM landing page at /decision-makers',
	description: 'Set true to enable page',
	import: false,
	deprecated: 'No references found. Safe to delete after 2026-09-01.',
});
